module.exports = __webpack_public_path__ + "img/ective_70Ah.26532bf9.png";